import React from "react";

function NewsEmptyContainer() {
  return (
    <div className="grid-cols-1 grid items-center justify-center text-center mobile:h-[224px] mt-28 mb-48">
      <div className="grid items-center justify-center">
        <img src="/assets/icons/news-icon.svg" />
      </div>
      <div className="mt-5">
        <p className="text-2xl font-meduim text-zinc-900 font-ar">
          لا يوجد اخبار منشورة{" "}
        </p>
        <p className="font-ar text-lg text-zinc-500 font-medium mt-3">
          قم باضافة خبر لمشاركته المهتمين في مدرستك{" "}
        </p>
        <button className="w-[122px] h-[43px] bg-mint-500 p-2 text-white font-ar rounded-md mt-3">
          انشئ خبر
        </button>
      </div>
    </div>
  );
}

export default NewsEmptyContainer;
